import React, { Suspense, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import LoadingScreen from "./LoadingScreen"; // Import the loading screen component
import "./fonts.css"; // Import the fonts.css here
import Pricing from "./Pricing";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import UnlockProfit from "./UnlockProfit";
import QuantoRetailERP from "./Products/QuantoRetailERP";
import MobileApp from "./Products/MobileApp";
import QuantoB2B from "./Products/QuantoB2B";
import Saas from "./Products/Saas";
import QuantofyP from "./Products/QuantofyP";
import QuantoCollect from "./Products/QuantoCollect";
import QuantoMfg from "./Products/QuantoMfg";
import QuantoMart from "./Products/QuantoMart";
import QuantoBridge from "./Products/QuantoBridge";
import PrivacyPolicy from "./PrivacyPolicy";
import "./style/LandingPage.css";
import ScrollToTop from "./ScrollToTop";
import WhatsappButton from "./WhatsappButton";
// import "./style/fadeTransition.css"; // Import the fade transition styles

const LandingPage = React.lazy(() => import("./LandingPage/LandingPage"));
const GetDemo = React.lazy(() => import("./GetDemo"));
const Features = React.lazy(() => import("./Features"));
const About = React.lazy(() => import("./AboutUs/About"));
const WhyQuanto = React.lazy(() => import("./WhyQuanto"));
const ClientsTrust = React.lazy(() => import("./ClientsTrust"));

function AppRouter() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [overlayIn, setOverlayIn] = useState(false);

  useEffect(() => {
    if (location.pathname == "/") {
      setIsLoading(false);
      setOverlayIn(false);
      console.log("HOME PAGE");
      return;
    }
    setIsLoading(true);
    setOverlayIn(false);
    const timer = setTimeout(() => {
      setIsLoading(false);
      setOverlayIn(true);
    }, 500); // Duration for the loading screen
    return () => clearTimeout(timer);
    // do for all pages except home
  }, [location.pathname]);

  return (
    <>
      {/* <div className={`black-overlay ${overlayIn ? 'fade-in' : 'fade-out'}`} /> */}
      {isLoading && (
        <LoadingScreen overlay={overlayIn ? "fade-in" : "fade-out"} />
      )}
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/get-demo" element={<GetDemo />} />
          <Route path="/features" element={<Features />} />
          <Route path="/about" element={<About />} />
          <Route path="/unlock-profit" element={<UnlockProfit />} />
          <Route path="/why-quanto" element={<WhyQuanto />} />
          <Route path="/clients-trust" element={<ClientsTrust />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route
            path="/products/quanto-retail-erp"
            element={<QuantoRetailERP />}
          />
          <Route path="/products/saas" element={<Saas />} />
          <Route path="/products/quanto-mobile-app" element={<MobileApp />} />
          <Route path="/products/quantofyP" element={<QuantofyP />} />
          <Route path="/products/quanto-b2b" element={<QuantoB2B />} />
          <Route path="/products/mfg" element={<QuantoMfg />} />
          <Route path="/products/mart" element={<QuantoMart />} />
          <Route path="/products/collect" element={<QuantoCollect />} />
          <Route path="/products/bridge" element={<QuantoBridge />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Suspense>
      <WhatsappButton />
      <ScrollToTop />
    </>
  );
}

function App() {
  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
        <AppRouter />
      </Suspense>
    </Router>
  );
}

export default App;
